<template>
  <div>
    <app-history
      @clicked="
        showDialog = true;
        currentPerson = initPerson;
        currentCode = '';
        currentFard = '';
        isEdit = false;
      "
      title="افزودن فرد"
    />

    <div>
      <v-data-table
        :items="people"
        :headers="peopleHeaders"
        class="elevation-1 rounded"
        :disable-pagination="true"
        :hide-default-footer="true"
        :no-data-text="tableText"
        :header-props="$store.getters.headerProps"
      >
        <template v-slot:[`item.isActive`]="{ item }">
          {{ item.isActive ? "بله" : "خیر" }}
        </template>
        <template v-slot:[`item.kprice`]="{ item }">
          {{ getItemDesc(item.kprice) }}
        </template>
        <template v-slot:[`item.actions`]="{ item }">
          <v-btn class="dialogButton" rounded @click="editItem(item)"
            >ویرایش</v-btn
          >
          <v-btn class="dialogButton" rounded @click="removeItem(item)"
            >حذف</v-btn
          >
        </template>
      </v-data-table>
    </div>

    <v-dialog v-model="showDialog" content-class="myDialog">
      <v-row align="center">
        <v-col class="d-flex" cols="12" sm="4">
          {{ isEdit ? "نام فرد:" : "انتخاب فرد:" }}
        </v-col>
        <v-col class="d-flex" cols="12" sm="8">
          <v-text-field
            v-if="!isEdit"
            v-model="currentCode"
            maxlength="12"
            :oninput="onInput"
            type="number"
          ></v-text-field>
          <span> {{ currentPerson.userName }}</span>
        </v-col>
      </v-row>
      <v-row align="center" v-if="!isEdit">
        <v-col class="d-flex" cols="12" sm="4"> </v-col>
        <v-col class="d-flex fardName" cols="12" sm="8">
          {{ currentFard }}
        </v-col>
      </v-row>
      <v-row align="center">
        <v-col class="d-flex" cols="12" sm="4"> تعرفه </v-col>
        <v-col class="d-flex" cols="12" sm="8">
          <v-select
            :items="priceTypes"
            item-text="text"
            item-value="value"
            v-model="currentPerson.kprice"
          ></v-select>
        </v-col>
      </v-row>
      <v-row align="center">
        <v-col class="d-flex" cols="12" sm="4"> مبلغ بدهی مجاز: </v-col>
        <v-col class="d-flex" cols="12" sm="8">
          <v-text-field
            v-model="currentPerson.mablaqBedehkariMojaz"
            maxlength="12"
            :oninput="onInput"
            type="number"
          ></v-text-field>
        </v-col>
      </v-row>
      <v-row align="center">
        <v-col class="d-flex" cols="12" sm="4">
          توضیحات:
        </v-col>
        <v-col class="d-flex" cols="12" sm="8">
          <v-textarea
            outlined
            v-model="currentPerson.description"
            no-resize
          ></v-textarea>
        </v-col>
      </v-row>
      <v-row align="center">
        <v-col class="d-flex" cols="10"> فعال: </v-col>
        <v-col class="d-flex ltr" cols="2">
          <v-switch v-model="currentPerson.isActive"></v-switch>
        </v-col>
      </v-row>

      <v-row class="ltr">
        <v-btn
          color="green white--text"
          class="dialogButton"
          rounded
          @click="applyRequest"
          :disabled="apiRunning"
        >
          ذخیره
        </v-btn>
        <v-btn
          class="dialogButton"
          rounded
          @click="
            showDialog = false;
            isEdit = false;
          "
        >
          انصراف
        </v-btn>
      </v-row>
    </v-dialog>
    <app-dialog @close="onCloseDialog"></app-dialog>
  </div>
</template>

<script>
import Vue from "vue";
import HistoryButton from "@/components/HistoryButton";
import Dialog from "@/components/Dialog";
import { GetAllOrderPeople, SavePerson, DeletePerson } from "@/api/orderpeople";
import { FindUserByCode } from "@/api/user";

export default {
  components: {
    appHistory: HistoryButton,
    appDialog: Dialog,
  },
  data() {
    return {
      showDialog: false,
      people: [],
      priceTypes: [
        { value: 1, text: "طلبه" },
        { value: 2, text: "استاد" },
        { value: 3, text: "پرسنل" },
        { value: 4, text: "آزاد" },
        { value: 5, text: "سایر" },
      ],
      currentPerson: {},
      currentCode: "",
      initPerson: {
        fardId: 0,
        kprice: 1,
        isActive: true,
        mablaqBedehkariMojaz: 10000,
        description: "",
        id: "0",
      },
      currentFard: "",
      isEdit: false,

      peopleHeaders: [
        {
          text: "شناسه",
          value: "id",
          width: "10%",
        },
        {
          text: "نام فرد",
          value: "userName",
          width: "20%",
          sortable: false,
        },

        {
          text: "تعرفه",
          value: "kprice",
          width: "10%",
        },
        {
          text: "مبلغ بدهی مجاز",
          value: "mablaqBedehkariMojaz",
          width: "10%",
        },
        {
          text: "فعال",
          value: "isActive",
          width: "10",
        },

        { text: "", value: "actions", sortable: false, align: "end" },
      ],
    };
  },
  created() {
    this.currentPerson = this.initPerson;
    if (this.currentBranch) this.GetAllOrderPeople();
  },
  computed: {
    tableText() {
      return this.$store.getters.tableText;
    },
    apiRunning() {
      return this.$store.getters.apiRunning;
    },
    currentBranch() {
      return this.$store.getters.currentBranch;
    },
    onInput() {
      return "this.value=this.value.slice(0,this.maxLength)";
    },
  },
  watch: {
    currentCode(value) {
      if (value.length == 10 || value.length == 12) {
        this.FindUser();
      } else {
        this.currentFard = "";
      }
    },
  },
  methods: {
    /**
     * expand khorooj
     */
    GetAllOrderPeople() {
      this.$store.commit("SET_TABLE_TEXT", true);
      return new Promise((resolve, reject) => {
        GetAllOrderPeople(this.currentBranch.id)
          .then((response) => {
            if (!response.data) {
              reject("error");
            }
            this.people = response.data.items;

            this.$store.commit("SET_TABLE_TEXT", false);

            resolve(response);
          })
          .catch((error) => {
            reject(error);
          });
      });
    },
    getItemDesc(kprice) {
      switch (kprice) {
        case 1:
          return "طلبه";
        case 2:
          return "استاد";
        case 3:
          return "پرسنل";
        case 4:
          return "آزاد";
        default:
          return "سایر";
      }
    },
    FindUser() {
      return new Promise((resolve, reject) => {
        FindUserByCode(this.currentCode)
          .then((response) => {
            if (!response.data) {
              reject("error");
            }
            const data = response.data.data;
            this.currentPerson.fardId = data.fardID;
            this.currentFard =
              data.fardID != 0
                ? data.name + " " + data.family
                : "موردی یافت نشد.";

            resolve(response);
          })
          .catch((error) => {
            reject(error);
          });
      });
    },
    editItem(item) {
      this.currentPerson = Object.assign({}, item);
      this.showDialog = true;
      this.isEdit = true;
    },
    removeItem(item) {
      this.$store.commit("SET_DIALOG_ICON", "exclamation");
      this.$store.commit("SET_DIALOG_TYPE", 1);
      this.$store.commit("SET_DIALOG_KEY", item.id);
      this.$store.commit(
        "SET_DIALOG_MESSAGE",
        "آیا مایل به حذف این فرد هستید؟"
      );
      this.$store.commit("SET_DIALOG_SHOW", true);
    },

    applyRequest() {
      var text = "";

      if (this.currentPerson.fardId == 0) {
        text = "فرد بایستی انتخاب شود.";
      }
      if (text != "") {
        this.$store.commit("SET_SNACKBAR_TEXT", text);

        return;
      } else {
        this.$store.commit("SET_API_RUNNING", true);
        SavePerson(
          this.currentPerson.id,
          this.currentBranch.id,
          this.currentPerson.fardId,
          this.currentPerson.mablaqBedehkariMojaz,
          this.currentPerson.kprice,
          this.currentPerson.isActive,
          this.currentPerson.description
        )
          .then((response) => {
            const data = response.data;
            this.$store.commit("SET_SNACKBAR_TEXT", data.message);
            this.$store.commit("SET_API_RUNNING", false);
            this.showDialog = false;
            this.GetAllOrderPeople();
          })
          .catch((error) => {
            this.$store.commit(
              "SET_SNACKBAR_TEXT",
              "خطایی به وجود آمده است لطفا مجددا تلاش کنید."
            );
          });
      }
    },

    /**
     * call remove api if user click on yes
     */
    onCloseDialog(index) {
      if (index != -1) {
        DeletePerson(index)
          .then((response) => {
            const data = response.data;
            this.$store.commit("SET_SNACKBAR_TEXT", data.message);

            if (data.success) {
              this.GetAllOrderPeople();
            }
          })

          .catch((error) => {
            this.$store.commit(
              "SET_SNACKBAR_TEXT",
              "خطایی به وجود آمده است لطفا مجددا تلاش کنید."
            );
          });
      }
      this.$store.commit("SET_DIALOG_SHOW", false);
    },
  },
};
</script>
